import { EAccessLevel, EPermissionTab, IPermissionMatrix } from 'entities/Permission/Permission.models';
import { EUserRole } from 'entities/User/User.models';

// FE nav-gating only — the BE module-guard is the real enforcement. A missing tab in the matrix
// means NoAccess. superadmin is wildcard (handled by callers via `isSuperAdmin`).
export const hasAccess = (
  permissions: IPermissionMatrix | null | undefined,
  tab: EPermissionTab,
  min: EAccessLevel = EAccessLevel.ViewOnly
): boolean => {
  const granted = permissions?.[tab] ?? EAccessLevel.NoAccess;

  return granted >= min;
};

export const isSuperAdminRole = (role?: string): boolean => role === (EUserRole.SuperAdmin as string);

// A franchisor user is the only role the permission overlay narrows. Every other role keeps its
// existing role-based access untouched (franchisee/salesop/manager/customer).
export const isFranchisorRole = (role?: string): boolean => role === EUserRole.Franchisor;
